import React from 'react';

const MobileFrameIcon = props => (
  <svg
    id="MobileFrameIcon_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 650 440"
    {...props}
  >
    <path
      fill="#D6D6D6"
      className="st0"
      d="M601 0H49C18.8 0 0-1.5 0 28.7v.3h650v-.3C650-1.5 631.2 0 601 0zM18.3 19.5c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8c.1 2.1-1.6 3.8-3.8 3.8z"
    />
    <path
      fill="#D6D6D6"
      className="st0"
      d="M647.2 31.5v405.7H2.8V31.5h644.4m2.8-2.8H0V440h650V28.7z"
    />
  </svg>
);

export default MobileFrameIcon;



// WEBPACK FOOTER //
// ./src/components/modules/CardStack/MobileFrameIcon.js